import { Category as TCategory } from "@/schema/free-assessment/Category";
import SubCategory from "@/src/free-assessment/questions/_components/Category/SubCategory/SubCategory";
import { AppsListRegular } from "@fluentui/react-icons";
import { Fragment } from "react";
import { Control, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CategoryProps {
  control: Control<{ categories: TCategory[] }>;
  categoryIndex: number;
  category: TCategory;
}

function Category({ control, categoryIndex, category }: CategoryProps) {
  const { t } = useTranslation();
  const { fields } = useFieldArray({
    control,
    name: `categories.${categoryIndex}.sub_categories`,
  });
  const subCategoryCount = fields.length;

  return (
    <div className="mx-4 mt-8 md:mx-16 lg:mx-32">
      <div className="text-2xl font-bold">{category.content}</div>
      {/* <div className="mt-2 flex gap-1 text-cool-gray-500"> */}
        {/* <AppsListRegular fontSize={20} /> */}
        {/* <span>{subCategoryCount} {t("sub-categories")}</span> */}
      {/* </div> */}
      <div className="mt-5 h-px bg-cool-gray-200" />
      {fields.map((subCategory, index) => (
        <Fragment key={subCategory.id}>
          <SubCategory
            categoryIndex={categoryIndex}
            subCategoryIndex={index}
            control={control}
            subCategory={subCategory}
          />
          {fields.length - 1 !== index && (
            <div className="mt-5 h-px bg-cool-gray-200" />
          )}
        </Fragment>
      ))}
    </div>
  );
}

export default Category;
